import React, { useState, useEffect, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { useContext } from "react";
import Notfound from "pages/notfound";
import Config from "services/config/config";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import FormSection from "components/sales/formSection/formSection";
import { toast } from "react-toastify";

const UserAccessDashboard = () => {
  const [inputData, setInputData] = useState({
    first_name: "",
    last_name: "",
    mobile_number: "",
    email_id: "",
    role: "",
    project_ids: "",
  });

  const handleInputValue = (key, val) => {
    setInputData({
      ...inputData,
      [key]: val, 
    });
  };

  const headerBtns = () => {
    return <Fragment></Fragment>;
  };

  const handleCreate = () => {
    if (inputData?.first_name == '') {
      toast.error('Please enter the first name')
      return false;
    }
    if (inputData?.last_name == '') {
      toast.error('Please enter the last name')
      return false;
    }
    if (inputData?.email_id == '') {
      toast.error('Please enter the email')
      return false;
    }
    if (inputData?.mobile_number == '') {
      toast.error('Please enter the mobile number')
      return false;
    }
    if (inputData?.role == '') {
      toast.error('Please select the role')
      return false;
    }
    if (inputData?.project_ids == '') {
      toast.error('Please enter the project ids')
      return false;
    }

    console.log("CREATION DATA: ", inputData);
  };

  return (
    <Layout title={"Create User"} Buttons={headerBtns}>
      <FormSection title="Create User">
        <div className="row">
          <div className="col-md-6">
            <ConstantInput
              label={"First Name"}
              errorMsg={localization.isRequired}
              type="text"
              required
              isStarRequired={true}
              value={inputData.first_name}
              handleChange={(val) => {
                handleInputValue("first_name", val);
              }}
              maxLength={100}
            />
          </div>
          <div className="col-md-6">
            <ConstantInput
              label={"Last Name"}
              errorMsg={localization.isRequired}
              type="text"
              required
              isStarRequired={true}
              value={inputData.last_name}
              handleChange={(val) => {
                handleInputValue("last_name", val);
              }}
              maxLength={100}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <ConstantInput
              label={"Email Id"}
              errorMsg={localization.isRequired}
              type="email"
              required
              isStarRequired={true}
              value={inputData.email_id}
              handleChange={(val) => {
                handleInputValue("email_id", val);
              }}
              maxLength={100}
            />
          </div>
          <div className="col-md-6">
            <ConstantInput
              label={"Mobile Number"}
              errorMsg={localization.isRequired}
              type="number"
              required
              isStarRequired={true}
              value={inputData.mobile_number}
              handleChange={(val) => {
                handleInputValue("mobile_number", val);
              }}
              maxLength={10}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
              data={[
                { id: "1", name: "Field Sales Executive" },
                { id: "2", name: "Team Lead" },
              ]}
              label={"Role"}
              required
              value={inputData.role}
              errorMsg={localization.isRequired}
              getIdValue={(val) => {
                handleInputValue("role", val?.id);
              }}
              isStarRequired={true}
            />
          </div>
          <div className="col-md-6">
            <ConstantInput
              label={"Project Ids"}
              errorMsg={localization.isRequired}
              type="text"
              required
              isStarRequired={true}
              value={inputData.project_ids}
              handleChange={(val) => {
                handleInputValue("project_ids", val);
              }}
              maxLength={100}
            />
          </div>
        </div>
        <span>
          <span style={{ color: "red" }}>*</span>
          <b>Add comma separated IDs without space</b>
        </span>
        <div className="mb-5 mt-5">
          <button
            type="submit"
            className="btn btn-primary btn-sm"
            onClick={handleCreate}
          >
            {"Create"}
          </button>
        </div>
      </FormSection>
    </Layout>
  );
};

export default UserAccessDashboard;
